import { useLayoutEffect, useRef, useState } from 'react';

export const useTextLines = <Element extends HTMLElement = HTMLElement>() => {
  const ref = useRef<Element>(null);
  const [linesState, setLinesState] = useState<{
    lineHeight: number;
    totalLines: number;
    visibleLines: number;
  }>();

  useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }

    const resizeObserver = new ResizeObserver(([textEl]) => {
      const lineHeight = parseFloat(getComputedStyle(textEl.target).lineHeight);
      const totalHeight = textEl.target.scrollHeight;
      const visibleHeight = textEl.target.clientHeight;

      setLinesState({
        lineHeight,
        totalLines: totalHeight / lineHeight,
        visibleLines: visibleHeight / lineHeight,
      });
    });

    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return [ref, linesState] as const;
};
